import * as _ from 'lodash';
import { Aggregate } from '../../../../models/aggregate';
import { EsPage } from '../../../../models/es-page';
import { CdxTask } from '../../../../models/cdx-task';


import { createReducer, on } from '@ngrx/store';
import {
    loadAggregateFailedAction,
    loadAggregateStartAction, loadAggregateSucceededAction,
    loadResultItemsFailedAction,
    loadResultItemsStartAction, loadResultItemsSucceededAction, removeSomeTasksFailedAction,
    removeSomeTasksStartAction, removeSomeTasksSucceededAction, updateSomeTasksFailedAction, updateSomeTasksStartAction,
    updateSomeTasksSucceededAction,
    updateTasksFailedAction, updateTasksStartAction, updateTasksSucceededAction, updateTaskSucceededAction,
    WkfSupervisionSearchResultConstantAction
} from '../action/wkf-supervision-search-result-action';


export const WKF_SUPERVISION_SEARCH_RESULT_INITIAL_STATE: WkfSupervisionSearchResultState = {
  datas: null,
  loading: false,
  loadAgg: false,
  error: null,
};

export interface WkfSupervisionSearchResultState {
  datas: EsPage<CdxTask>;
  loading: boolean;
  loadAgg: boolean;
  error: any;
}



export const wkfSupervisionSearchResultReducer = createReducer(
  WKF_SUPERVISION_SEARCH_RESULT_INITIAL_STATE,
  on(loadResultItemsStartAction, (state) => ({
    ...state,
    loading: true,
    error: WkfSupervisionSearchResultConstantAction.ERROR_START,
  }) ),
  on(loadResultItemsSucceededAction, (state, {payload}) => ({
    ...state,
    datas: payload,
    loading: false,
    error: null,
  }) ),
  on(loadResultItemsFailedAction, (state, {error}) => ({
    ...state,
    datas: undefined,
    loading: false,
    error: error,
  }) ),
  on(loadAggregateStartAction, (state) => ({
    ...state,
    loading: true,
    loadAgg: true,
    error: WkfSupervisionSearchResultConstantAction.ERROR_START,
  }) ),
  on(loadAggregateSucceededAction, (state, {payload}) => {
    const newAgg: Aggregate = payload.aggs[0];
    let aggs: Aggregate[] = state.datas.aggs;
    let added = false;
    aggs = aggs.map(agg => {
      if (agg.path === newAgg.path) {
        added = true;
        return newAgg;
      }
      return agg;
    });
    if (!added) {
      aggs.push(newAgg);
    }
    const copy = {...state.datas, aggs: aggs};

    return (
    {
    ...state,
    datas: copy,
    loading: false,
    loadAgg: false,
    error: null,
  })} ),
  on(loadAggregateFailedAction, (state, {error} ) => ({
    ...state,
    loading: false,
    loadAgg: false,
    error: error,
  }) ),
  on(updateTasksStartAction, (state) => ({
    ...state,
    loading: true,
    error: WkfSupervisionSearchResultConstantAction.ERROR_START,
  }) ),
  on(updateTasksSucceededAction, (state, {payload}) => ({

    ...state,
    datas: {...state.datas,
      content: payload.content,
      numberOfElements: payload.numberOfElements,
      size: payload.size,
      page: payload.page
    },
    loading: false,
    error: null,
  }) ),
  on(updateTasksFailedAction, (state, {error}) => ({
    ...state,
    loading: true,
    error: error,
  }) ),
  on(updateTaskSucceededAction, (state, {payload}) => {
    const updatedTask = payload.content[0];
    const contentIndex = state.datas.content.findIndex(cdxTask => cdxTask?.cdx_wkf?.cdx_process?.task_instance_id === updatedTask?.cdx_wkf?.cdx_process?.task_instance_id);

    if (contentIndex !== -1) {
      state.datas.content.splice(contentIndex, 1, updatedTask);
    }

    return {
      ...state,
      datas: {
        ...state.datas,
        content: state.datas.content,
      },
      loading: false,
      loadAgg: false,
      error: null,
    };
  }),
  on(updateSomeTasksStartAction, (state) => ({
    ...state,
    loading: true,
    error: WkfSupervisionSearchResultConstantAction.ERROR_START,
  }) ),
  on(updateSomeTasksSucceededAction, (state, {payload}) => {
    const datasCopy = _.cloneDeep(state.datas);
    payload.forEach( (updatedTask) => {
      const contentIndex = state.datas.content.findIndex(cdxTask => cdxTask?.cdx_wkf?.cdx_process?.task_instance_id === updatedTask?.cdx_wkf?.cdx_process?.task_instance_id);
          if (contentIndex !== -1) {
            datasCopy.content.splice(contentIndex, 1, updatedTask);
          }
        }
    );

    return {
      ...state,
      datas: datasCopy,
      loading: false,
      loadAgg: false,
      error: null,
    };

  }),
  on(updateSomeTasksFailedAction, (state, {error}) => ({
    ...state,
    loading: true,
    error: error,
  }) ),
  on(removeSomeTasksStartAction, (state) => ({
  ...state,
  loading: true,
  error: WkfSupervisionSearchResultConstantAction.ERROR_START,
  }) ),
  on(removeSomeTasksSucceededAction, (state, {payload}) => {
    const datasCopy = _.cloneDeep(state.datas);
    payload.forEach( (taskToRemove) => {
          const contentIndex = state.datas.content.findIndex(cdxTask => cdxTask?.cdx_wkf?.cdx_process?.task_instance_id === taskToRemove?.cdx_wkf?.cdx_process?.task_instance_id);
          if (contentIndex !== -1) {
            datasCopy.content.splice(contentIndex, 1 );
          }
        }
    );

    return {
      ...state,
      datas: datasCopy,
      loading: false,
      loadAgg: false,
      error: null,
    };

  }),
  on(removeSomeTasksFailedAction, (state, {error}) => ({
    ...state,
    loading: true,
    error: error,
  }) ),
);
